/**
 * Post-Launch Optimization Dashboard Page
 * Main page for post-launch optimization and continuous improvement
 */

import React from 'react';
import PostLaunchOptimizationDashboard from '../../components/postlaunch/PostLaunchOptimizationDashboard';

const PostLaunchOptimizationDashboardPage = () => {
  return (
    <div>
      <PostLaunchOptimizationDashboard />
    </div>
  );
};

export default PostLaunchOptimizationDashboardPage;
